"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_native_1 = require("react-native");
const colors_1 = __importDefault(require("../../styles/colors"));
const styles = react_native_1.StyleSheet.create({
    icon: {
        backgroundColor: colors_1.default.BLUE_2,
        width: 100,
        height: 100,
        borderRadius: 15,
    },
    title: {
        fontSize: 30,
        fontWeight: '900',
    },
    subTitle: {
        fontSize: 15,
        fontStyle: 'italic',
        fontWeight: '100',
    },
    maxWidthFifty: {
        maxWidth: 50,
    },
    maxWidthTwoHundred: {
        maxWidth: 200,
    },
    minWidthTwoFifty: {
        minWidth: 250,
    },
});
exports.default = styles;
